<template>
    <div>
        <b-container fluid class="px-0">
            <b-card id="card-principal" class="mb-0 pb-0">
                <template #header>
                    <div class="flex-grow-1">
                        <i class="fas fa-edit"></i>
                        <strong>{{$lang.Menu.Items.PCI.PDRGoalRegistration}}</strong>
                    </div>
                </template>
                <b-row>
                    <b-tabs id="tab" pills card>
                        <b-tab title="Metas de Itens">
                            <ag-grid-vue style="width: 100%; height: calc(100vh - 510px)"
                                class="ag-theme-alpine"
                                :rowMultiSelectWithClick="false"
                                rowSelection="single"
                                :getLocaleText="localeTextFunc"
                                :gridOptions="itemGridOptions"
                                :columnTypes="columnTypes"
                                :columnDefs="itemColumnDefs"
                                :defaultColDef="defaultColumnDef"
                                :rowData="itemRowData"
                                :suppressColumnVirtualisation=true
                                @gridReady="onGridItemReady"
                                >
                            </ag-grid-vue>
                            <div class="align-right">
                                <button type="button" class="btn btn-third btn-sm" v-b-tooltip.hover v-on:click="showGoalItensModal">
                                    <i class="fa fa-plus"></i>&nbsp;&nbsp;Nova Meta
                                </button>
                            </div>
                        </b-tab>
                        <b-tab title="Metas de Função">
                            <ag-grid-vue style="width: 100%; height: calc(100vh - 510px)"
                                class="ag-theme-alpine"
                                :rowMultiSelectWithClick="false"
                                rowSelection="single"
                                :getLocaleText="localeTextFunc"
                                :gridOptions="functionGridOptions"
                                :columnTypes="columnTypes"
                                :columnDefs="functionColumnDefs"
                                :defaultColDef="defaultColumnDef"
                                :rowData="functionRowData"
                                :suppressColumnVirtualisation=true
                                @gridReady="onGridFunctionReady"
                                >
                            </ag-grid-vue>
                            <div class="align-right">
                                <button type="button" class="btn btn-third btn-sm" v-b-tooltip.hover v-on:click="showGoalFunctionModal">
                                    <i class="fa fa-plus"></i>&nbsp;&nbsp;Nova Meta
                                </button>
                            </div>
                        </b-tab>
                    </b-tabs>
                </b-row>
            </b-card>
        </b-container>

        <!-- Meta Itens -->
        <b-modal
            v-model="showGoalItens"
            title="Cadastrar Metas de itens"
            size="md"
            :hide-footer="true"
            centered>
            <div class="d-flex flex-column justify-content-start">
                <b-row><b-col><b>Escolher Item</b></b-col></b-row>
                <b-row>
                    <b-col>
                        <b-form-select id="select-available"
                            class="select-contracts form-control"
                            :options="availableItens.options"
                            v-model="goalItemForm.pdrformularioitemid">
                        </b-form-select>
                    </b-col>
                </b-row>
                <b-row><b-col><hr/><b>Meta do item</b></b-col></b-row>
                <b-row>
                    <b-col>Operador</b-col>
                    <b-col>Valor</b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-select
                            class="select-contracts form-control"
                            :options="availableOperators"
                            v-model="goalItemForm.operacaoItem">
                        </b-form-select>
                    </b-col>
                    <b-col>
                        <b-form-input type="number"
                            v-model="goalItemForm.metaItem"
                            :value="goalItemForm.metaItem" />
                    </b-col>
                </b-row>
                <b-row><b-col><hr/><b>Meta da Obra</b></b-col></b-row>
                <b-row>
                    <b-col>Operador</b-col>
                    <b-col>Valor</b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-select
                            class="select-contracts form-control"
                            :options="availableOperators"
                            v-model="goalItemForm.operacaoObra">
                        </b-form-select>
                    </b-col>
                    <b-col>
                        <b-form-input type="number" v-model="goalItemForm.metaObra" :value="goalItemForm.metaObra" />
                    </b-col>
                </b-row>
                <b-row><b-col><hr/><b>Vigência</b></b-col></b-row>
                <b-row>
                    <b-col>Início</b-col>
                    <b-col>Término</b-col>
                </b-row>
                <b-row>
                    <b-col><b-form-input type="date" v-model="goalItemForm.inicio" :value="goalItemForm.inicio" /></b-col>
                    <b-col><b-form-input type="date" v-model="goalItemForm.termino" :value="goalItemForm.termino" /></b-col>
                </b-row>
                <b-row>
                    <b-col class="align-right">
                        <hr />
                        <button type="button" class="btn btn-third btn-sm" v-on:click="sendItemForm" v-b-tooltip.hover>
                            <i class="fa fa-check"></i>&nbsp;&nbsp;Adicionar
                        </button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <!-- Meta Função -->
        <b-modal
            v-model="showGoalFunction"
            title="Cadastrar Metas de Função"
            size="md"
            :hide-footer="true"
            centered>
            <div class="d-flex flex-column justify-content-start">
                <b-row><b-col><b>Escolher Função</b></b-col></b-row>
                <b-row>
                    <b-col>
                        <b-form-select id="select-available"
                            class="select-contracts form-control"
                            :options="availableFunctions.options"
                            v-model="goalFunction.funcaoobraid">
                        </b-form-select>
                    </b-col>
                </b-row>
                <b-row><b-col><hr/><b>Meta da Função</b></b-col></b-row>
                <b-row>
                    <b-col>Operador</b-col>
                    <b-col>Valor</b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-select
                            class="select-contracts form-control"
                            :options="availableOperators"
                            v-model="goalFunction.operacaoItem">
                        </b-form-select>
                    </b-col>
                    <b-col>
                        <b-form-input type="number"
                            v-model="goalFunction.metaItem"
                            :value="goalFunction.metaItem" />
                    </b-col>
                </b-row>
                <b-row><b-col><hr/><b>Vigência</b></b-col></b-row>
                <b-row>
                    <b-col>Início</b-col>
                    <b-col>Término</b-col>
                </b-row>
                <b-row>
                    <b-col><b-form-input type="date" v-model="goalFunction.inicio" :value="goalFunction.inicio" /></b-col>
                    <b-col><b-form-input type="date" v-model="goalFunction.termino" :value="goalFunction.termino" /></b-col>
                </b-row>
                <b-row>
                    <b-col class="align-right">
                        <hr />
                        <button type="button" class="btn btn-third btn-sm" v-on:click="sendFunctionForm" v-b-tooltip.hover>
                            <i class="fa fa-check"></i>&nbsp;&nbsp;Adicionar
                        </button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
import GoalRegistration from './goalRegistration.js'
export default GoalRegistration
</script>

<style scoped>
    #tab {
        width: 100%;
        margin: 0px 5px 0px 5px;
    }
    .align-right {
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/goalRegistration/goalRegistration.vue